import LinesService from './LinesService';
import VtItensService from './VtItensService';

interface LineFareCache {
  faresByRouteId: Map<string, number>;
  expiresAt: number;
}

class LineFaresService {
  private cache: LineFareCache | null = null;
  private inFlightPromise: Promise<Map<string, number>> | null = null;

  async getFaresMap({
    token,
    codUsu,
    perfilUsu,
  }: {
    token: string;
    codUsu?: number;
    perfilUsu?: number;
  }): Promise<Map<string, number>> {
    if (this.cache && Date.now() < this.cache.expiresAt) {
      return this.cache.faresByRouteId;
    }

    if (this.inFlightPromise) {
      return this.inFlightPromise;
    }

    this.inFlightPromise = (async () => {
      try {
        const [linesRes, vtItensRes] = await Promise.all([
          LinesService.listLines({ token, codUsu, perfilUsu }),
          VtItensService.listVtItens({ token, codUsu, perfilUsu }),
        ]);

        const faresByCodItemRot = new Map<string, number>();
        if (vtItensRes?.listaItensVT && Array.isArray(vtItensRes.listaItensVT)) {
          for (const item of vtItensRes.listaItensVT) {
            if (item.codItemRot && typeof item.tarifa === 'number') {
              faresByCodItemRot.set(String(item.codItemRot).trim(), item.tarifa);
            }
          }
        }

        const faresByRouteId = new Map<string, number>();
        if (linesRes?.linhas && Array.isArray(linesRes.linhas)) {
          for (const line of linesRes.linhas) {
            if (line.routeID) {
              const itemRot = line.codItemRot ? String(line.codItemRot).trim() : '';
              const tarifa = faresByCodItemRot.get(itemRot);
              if (tarifa != null) {
                faresByRouteId.set(String(line.routeID).trim(), tarifa);
              }
            }
          }
        }

        this.cache = {
          faresByRouteId,
          expiresAt: Date.now() + 10 * 60 * 1000,
        };

        return faresByRouteId;
      } catch (err) {
        console.warn('Could not load line fares map', err);
        return new Map<string, number>();
      } finally {
        this.inFlightPromise = null;
      }
    })();

    return this.inFlightPromise;
  }
}

export default new LineFaresService();
